<template>
  <form @submit.prevent="processForm" class="columns mb-4">
    <div class="column is-10">
      <div class="columns is-multiline">
        <div class="column is-6">
          <b-field>
            <b-input
              v-model="form.search"
              placeholder="Nombre, apodo o palabra clave"
              :disabled="state.loading ? true : false"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field>
            <b-input
              v-model="form.description"
              placeholder="palabra clave"
              :disabled="state.loading ? true : false"
            ></b-input>
          </b-field>
        </div>
        <div class="column is-3">
          <b-field>
            <b-autocomplete
              v-model="locdes"
              placeholder="Lugar"
              field="cod_geo"
              group-fields="nom_prov"
              @typing="filterGeos"
              @select="getCodGeo"
              :clearable="true"
              :custom-formatter="(v) => v.nom_loc"
              :data="state.geos"
              :disabled="state.loading ? true : false"
              :keep-first="true"
              :loading="state.loadingGeos"
              :open-on-focus="true"
            >
            </b-autocomplete>
          </b-field>
        </div>
        <div class="column is-6">
          <b-field>
            <b-datepicker
              v-model="form.fecha_min"
              placeholder="Desde esta fecha"
              :date-parser="dateParse"
              :date-format="dateFormat"
              :min-date="minDate"
              :max-date="maxDate"
              :focused-date="minDate"
              :disabled="state.loading ? true : false"
            />
          </b-field>
        </div>
        <div class="column is-6">
          <b-field>
            <b-datepicker
              v-model="form.fecha_max"
              placeholder="Hasta esta fecha"
              :date-parser="dateParse"
              :date-format="dateFormat"
              :min-date="minDate"
              :max-date="maxDate"
              :focused-date="maxDate"
              :disabled="state.loading ? true : false"
            />
          </b-field>
        </div>
      </div>
    </div>
    <div class="column is-2">
      <div class="columns is-flex-direction-column">
        <div class="column is-12">
          <b-button
            class="button is-primary"
            :disabled="state.loading ? true : false"
            native-type="submit"
          >
            Buscar
          </b-button>
        </div>
        <div class="column is-12">
          <b-button
            class="button is-light"
            :disabled="state.loading ? true : false"
            @click="clearForm"
          >
            Limpiar
          </b-button>
        </div>
      </div>
    </div>
  </form>
</template>
<script>
import store from "../store";
import { DateTime } from "luxon";

export default {
  methods: {
    clearForm() {
      this.form.search = null;
      this.form.fecha_min = null;
      this.form.fecha_max = null;
      this.form.description = null
      this.form.lugar = null;
      this.locdes = null;
    },
    dateParse(value) {
      return Date(value);
    },
    dateFormat(value) {
      return DateTime.fromISO(String(value), { zone: "utc" }).toISODate();
    },
    places(name) {
      let toFetch = "/presentes/api/geos/";
      if (name) {
        toFetch += `?search=${name}`;
      }
      this.state.loadingGeos = true;
      const req = this.$http.get(toFetch);
      req.then((resp) => {
        if (resp.status >= 400 && resp.status < 600) {
          throw resp;
        }
        resp.json().then((json) => {
          this.state.geos = [];
          json.results.forEach((item) => this.state.geos.push(item));
        });
        this.state.loadingGeos = false;
      });
    },
    processForm() {
      const { form, state } = this.$data;
      const cleanedData = store.cleanParams(form);
      if (cleanedData.fecha_max) {
        cleanedData.fecha_max = this.dateFormat(cleanedData.fecha_max);
      }
      if (cleanedData.fecha_min) {
        cleanedData.fecha_min = this.dateFormat(cleanedData.fecha_min);
      }
      state.query = cleanedData;
      state.model.fetchMany(cleanedData);

      this.$router.push({ name: "Home", query: cleanedData });
    },
    getCodGeo(value) {
      this.form.lugar = value.cod_geo;
    },
    filterGeos(name) {
      return store.places(name);
    },
  },
  beforeMount() {
    this.places();
    const query = Object.assign({}, this.$route.query);
    store.state.query = query;
  },
  data() {
    const minDate = new Date("1/1/1966");
    const maxDate = new Date("31/12/1983");
    let fechaMin = store.state.query.fecha_min;
    let fechaMax = store.state.query.fecha_max;
    if (fechaMin) {
      fechaMin = this.dateFormat(fechaMin);
    }
    if (fechaMax) {
      fechaMax = this.dateFormat(fechaMax);
      store.state.query = fechaMax
    }

    return {
      state: store.state,
      form: {
        lugar: store.state.query.lugar,
        search: store.state.query.search,
        fecha_min: fechaMin,
        fecha_max: fechaMax,
        description: null
      },
      locdes:'',
      minDate,
      maxDate,
    };
  },
};
</script>
